import React, { useEffect, useState, Fragment } from 'react';
import { isEmpty } from "lodash"

import Spin from '../../../commonModules/interface/Spin.jsx';
import { CardLayout, BreadCrumb } from './containers/Layout.jsx';
import ListSaleItem from './sales/ListSaleItem.jsx';
import ListQuote from './transfers/quote/ListTransferQuote.jsx';
import Form from './quote/Form.jsx';
// import SingleSale from './sales/SingleSale.jsx';
import SingleShop from './shops/SingleShop.jsx';
import { Button, Card, Grid, Box, IconButton } from '@material-ui/core';
import { ListRounded, ListAltRounded } from '@material-ui/icons';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline.jsx';
import { firstDayOfYear, sixMonthsAgo } from '../../../commonModules/utils/statsFunctions.jsx';
import DateFilter, { filterDate } from './Filter/DateFilter.jsx';
import ShopFilter, { filterShop } from './Filter/ShopFilter.jsx';
import AccordionFilter from './Filter/AccordionFilter.jsx';
import SingleTransferSale from './transfers/sales/SingleTransferSale.jsx';

const Quote = (props) => {
    const [end_date,setEnd_date] = useState(new Date());
    const [clients,setClients] = useState([]);
    const [state, setState] = useState({
        view: props.new ? "new" : "list",
        listview: "quote",

        singleShop:{},
        singleSale:{
            sale:{},
            shop:{},
            client:{},
            agent:{},
        },

        breadcrumb: "",
        currentPage: 0,
        currentPageProd: 0,
        rowsPerPage: 20,

        selectShop: {label:"", value:""},
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchCredit: "", 
        searchProduct: "", 
		// start_date: firstDayOfYear,
		start_date: sixMonthsAgo,
    })
        
    useEffect(() => {
        if(isEmpty(props.QUOTE)){
            props.fetchAgents()
        }
        let clients = createClientList()
        setClients(clients)
        const endOfDay = new Date();
        endOfDay.setHours(23, 59, 59);
        setEnd_date(endOfDay);
    }, []);
    useEffect(() => {
        let clients = createClientList()
        setClients(clients)
    }, [props.CLIENTS]);
    
    // select options 
    const createShopList = () => {
            const list = [{value:"", label:"Tous les Magasins"}]
            const { SHOPS } = props
            if( !isEmpty(SHOPS) ){
                Object.values(SHOPS).forEach( shop => { 
                    list.push (       
                        {value:shop.id, label:shop.name} 
                    )
                })
            } 
            return list
        }
        const createClientList = () => {
            const list = [{value:"", label:"Tous les Clients"}]
            const { CLIENTS } = props
            if( CLIENTS ){
                Object.values(CLIENTS).map(client => { 
                    list.push (       
                        {value:client.id, label:client.client_lastname} 
                    )
                })
            } 
            return list
        }
        const normalizeStr = (str) => {// remove accent and lower case str
            if (str){
                console.log("str exist", {str}, isEmpty(str));
                str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
            return str
        }
        const prodFilter = (prodID) => {
            const { PRODUCTS } = props;
            const { searchProduct } = state
    
            let product = PRODUCTS[prodID]
            let searching = searchProduct ? normalizeStr(searchProduct) : ""
    
            const productName = product ? normalizeStr(product.name) : ""
            const productRef = product ? normalizeStr(product.ref) : ""
            const productType = product ? normalizeStr(product.type) : ""
            const productBrand = product ? normalizeStr(product.marque) : ""
    
            return ( 
                productName.indexOf(searching) !== -1 ||
                productRef.indexOf(searching) !== -1 ||
                productType.indexOf(searching) !== -1 ||
                productBrand.indexOf(searching) !== -1
            )  
        }

        const handleChange = (e) => {
            const { name, value } = e.target;
            setState(prevState => ({...prevState,
                [name]: value,
                currentPage: 0,
                currentPageProd: 0,
            }))
        }
        const handleSelect = (option, name) => {
            setState(prevState => ({...prevState,
                [name]: option.value, 
                currentPage: 0,
                currentPageProd: 0,
            }))
        } 

        const handleSelectMulti = (option, name) => {
            if(option){
                setState(prevState => ({...prevState,
                    [name]: option,
                    currentPage: 0,
                    currentPageProd: 0,
                }))
            } else {
                setState(prevState => ({...prevState,
                    [name]: {label: "", value: ""},
                    currentPage: 0,
                    currentPageProd: 0,
                }))
    
            }
        }
        const getFilteredList = () => {
            const { QUOTES } = props;
            const { selectShop, searchClient, searchFacture, searchType, searchCredit } = state;
            
            let list = filterDate(QUOTES, state.start_date, end_date, "creation_date")
            // status
            if (typeof searchCredit == "boolean"){
                list = list.filter(item => item.sale_credit == searchCredit)
            }
            // client
            if (!isEmpty(searchClient)) {
                list = list.filter(item => item.client_ref === searchClient || item.sale_paygo_id === searchClient )
                // list = list.filter(item => filterClients(item))
            }
            // type
            if(!isEmpty(searchType)){
                if (searchType === "commercial") {
                    list = list.filter(item => item.shop_id === "Commercial")
                } else {
                    list = list.filter(item => item.nature === searchType)
                }
            }
            // shop
            // if(!isEmpty(selectShop)){
            //     list = list.filter(item => item.shop_id === selectShop)
            // }
            list = filterShop(list, selectShop)

            // fact
            if(!isEmpty(searchFacture)){
                const normalizeRef = (s) => (s || '').toString().toLowerCase().replace(/[-/\s_]/g, '');
                const search = normalizeRef(searchFacture);
                list = list.filter(item =>
                    normalizeRef(item.id).indexOf(search) > -1 ||
                    normalizeRef(item.intern_ref_id).indexOf(search) > -1
                );
            }
            return list
        }
        
    // CLEAR & DISPLAY
    const handleClose = () => {
        setState(prevState => ({...prevState,
                view:"list",
                breadcrumb: "",
            }));
        }
        const handleSingleSale = (sale, shop, client, agent) => {
            setState(prevState => ({...prevState,
                view:"quote",
                breadcrumb:`${sale.nature} n°${sale.id}`,
                singleSale:{sale, shop, client, agent},
            }))
        }
        const handleSingleShop = (shop) => {
            setState(prevState => ({...prevState,
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            }))
        }
        const onChangePage = (pageOfItems, page, rowsPerPage) => {
            setState(prevState => ({...prevState,
                currentPage:page, rowsPerPage }));
        }
        const onChangePageProd = (pageOfItemsProd, page , rowsPerPage) => {
            setState(prevState => ({...prevState,
                currentPageProd:page , rowsPerPage}));
        }


        return(
            <CardPage title="Cotations" storehouse action={
                <Box>
                    {state.view === "list" &&
                    <Fragment>
                        <Button color="primary" variant="contained"
                            onClick={ ()=> setState(prevState => ({...prevState,view: "new", breadcrumb:"Nouveau"})) }
                        > Nouvelle Cotation </Button>
                        {state.listview === "quote" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Produits"
                                onClick={()=> setState(prevState => ({...prevState, view: "list", listview: "prodList" })) }
                            >
                                <ListRounded />
                            </IconButton>
                        }
                        {state.listview === "prodList" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Ventes"
                                onClick={()=> setState(prevState => ({...prevState, view: "list", listview: "quote" })) }
                            >
                                <ListAltRounded />
                            </IconButton>
                        }
                    </Fragment>
                    }
                </Box>
            }>
                <BreadCrumb breadcrumb={ state.breadcrumb } title="Cotations" back={handleClose} />
                {state.view === "new" &&
                    <Form {...props} handleClose={ handleClose } />
                }
                {state.view === "quote" &&
                    <SingleTransferSale 
                        sale={state.singleSale.sale} 
                        transfer={state.singleSale.sale} 
                        shop={state.singleSale.shop} 
                        client={state.singleSale.client} 
                        agent={state.singleSale.agent} 
                        {...props} 
                        getPhoto={props.getPhoto} />
                }
                {state.view === "shop" &&
                    <SingleShop shop={state.singleShop} {...props} />
                }
                  
                {state.view === "list" &&
                // {state.view === "list" && (state.listview === "sale" ||  state.listview === "prodList") &&
                <AccordionFilter>
                    <Grid container>
                        <DateFilter
                            handleChangeDate={(date, name) => {if(name==="end_date"){setEnd_date(date)}else{setState(prevState => ({...prevState, [name]: date }))}}}
                            {...state}
                        />
                        <Grid item xs={12} md={6}>
                            {/* <InputSelect
                                options={shops}
                                value={state.selectShop}
                                label="Sélectionner un Magasin"
                                onChange={(option) => handleSelect(option, "selectShop") }
                            />  */}
                            <ShopFilter
                                fieldName="selectShop"
                                value={state.selectShop}
                                handleSelect={handleSelectMulti}
                            />
                        </Grid>                       
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={clients}
                                value={state.searchClient}
                                label="Client"
                                onChange={(option) => handleSelect(option, "searchClient") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputText
                                label="Numéro Devis"
                                value={state.searchFacture}
                                name="searchFacture"
                                onChange={handleChange}
                            /> 
                        </Grid>
                        {state.listview === "prodList" &&
                        <Grid item xs={12} md={6}>
                            <InputText 
                                name="searchProduct" 
                                value={state.searchProduct} 
                                placeholder="Rechercher par produit " 
                                label="Rechercher"
                                onChange={ handleChange} 
                            />
                        </Grid>
                        }
                    </Grid>
                </AccordionFilter>
                }
                {props.STATE && props.STATE.quotes && props.STATE.quotes.fetching && <Spin noOverlay />}
               
                {state.view === "list" && state.listview === "quote" &&
                <Box>                    
                        <ListQuote 
                            {...props}
                            {...state}
                            dataview={"quote"}
                            onChangePage={onChangePage}
                            handleSingleShop={handleSingleShop}  
                            handleSingleSale={handleSingleSale}  
                            getFilteredList={getFilteredList}  
                            prodFilter={prodFilter}  
                        />
                </Box>
                }
                {state.view === "list" && state.listview === "prodList" &&
                <Box> 
                    {!isEmpty(props.QUOTES) &&
                        <ListSaleItem
                            {...props}
                            {...state}
                            dataview="quote"
                            onChangePage={onChangePageProd}
                            handleSingleShop={handleSingleShop}  
                            handleSingleSale={handleSingleSale}  
                            getFilteredList={getFilteredList}  
                            prodFilter={prodFilter}  
                        />
                    }
                </Box>
                }
            </CardPage>
        )
}

export default Quote